import { ChildSex } from 'types';
import { FemaleIcon, MaleIcon } from 'assets';

export const ChildSexDisplay = ({ sex }: { sex: ChildSex }) =>
    sex === 'MALE' ? <MaleIcon /> : <FemaleIcon />;
